import { TFullTimezone } from '~/utils/timezone.utils';
export const LEAD_INFO_INPUT_NAMES = [
    'leadInfoFullName',
    'leadInfoEmail'
] as const;

export type TLeadInfoInputNames = (typeof LEAD_INFO_INPUT_NAMES)[number];

export type TPublicFlowSubmitData = Record<string, any> &
    Record<TLeadInfoInputNames, string>;

export type TLeadFormSubmitSchedulerData = {
    page_id: string;
    data: {
        user_ids?: string[];
        // if we are submitting with pay, the scheduling will happen in a client
        // pending task, so we don't have the user_ids in this point yet
        selected_date: string;
        client_timezone: TFullTimezone;
    };
};
